<template>
  <div class="content">
    
    <div class="holder container">
      <div class="content-detail">
        <img :src="currentBanner" alt="postcard" />
      </div>
      <div class="content-button">
        <div
          class="btn-custom active"
          @click="gotoCreatePostCard"
        >{{ $t("front_end.a005.btn.create_postcard") }}</div>
        <div @click="onOpenModalA095" class="btn-custom">
          <p class="m-0 text-box">{{ $t("front_end.a005.btn.reorder.text1") }}</p>
          <p class="m-0 text-box">{{ $t("front_end.a005.btn.reorder.text2") }}</p>
        </div>
      </div>

      <!-- <button @click="showErr">TEst</button> -->
    </div>
    <!-- <fe-alert ref="modalAlertA105" :datas="dataAlertA105">
      <template v-slot:default>
        <div class="alert-center">{{ dataAlertA105.content }}</div>
      </template>
    </fe-alert>-->
    <!-- <A105Modal
      ref="modalA105"
      @show-alert="() => { this.$refs.modalAlertA105.show() }"
      @result="saveOrderToStore($event)"
    ></A105Modal>-->
    <!-- base alert -->
    <!-- <base-alert ref="alertComponent" :datas="dataAlert" @confirm-ok="onConfirmOk"></base-alert> -->
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import categoryDefinitions from "@/mixins/categoryDefinitions";
import envConfig from "@/configs/env/config";
// import BaseAlert from "@/components/be/common/BaseAlert";
// import FeAlert from "@/components/fe/common/FeAlert";
// import A105Modal from "@/views/fe/A105.vue";

export default {
  name: "A005",
  components: {
    // FeAlert,
    // BaseAlert
    // A105Modal
    // A095Modal
  },
  computed: {
    ...mapGetters(["shopMode"]),
    phoneNumber() {
      return this.reOrder.phone1 + this.reOrder.phone2 + this.reOrder.phone3;
    },
    currentBanner() {
      let dNow = this.$moment();
      let utcOffset = dNow.utcOffset();
      let timeZoneIso = "+" + this.converTo2Digit(utcOffset / 60) + ":00";
      let { years, months, date, hours, minutes, seconds } = dNow.toObject();

      let url = "/placeholder-image.jpg";

      let strDateNow =
        years +
        "-" +
        this.converTo2Digit(months + 1) +
        "-" +
        this.converTo2Digit(date) +
        "T" +
        this.converTo2Digit(hours) +
        ":" +
        this.converTo2Digit(minutes) +
        ":" +
        this.converTo2Digit(seconds) +
        timeZoneIso;
      let momentNow = this.$moment(strDateNow);

      for (let index = 0; index < envConfig.BANNER_SCHEDULES.length; index++) {
        const mileStone = envConfig.BANNER_SCHEDULES[index];
        let isCross = false;
        if (
          mileStone.from.month > mileStone.to.month ||
          (mileStone.from.month == mileStone.to.month &&
            mileStone.from.day > mileStone.to.day)
        ) {
          isCross = true;
        }

        let fromDate = null;
        let toDate = null;

        //thuan
        if (!isCross) {
          let fromMonth2Digit = this.converTo2Digit(mileStone.from.month);

          let fromDay2Digit = this.converTo2Digit(mileStone.from.day);
          fromDate = this.$moment(
            years +
              "-" +
              fromMonth2Digit +
              "-" +
              fromDay2Digit +
              "T00:00:01" +
              timeZoneIso
          );

          let tomonth2digit =
            mileStone.to.month < 10
              ? "0" + mileStone.to.month
              : mileStone.to.month;
          let today2digit =
            mileStone.to.day < 10 ? "0" + mileStone.to.day : mileStone.to.day;
          toDate = this.$moment(
            years +
              "-" +
              tomonth2digit +
              "-" +
              today2digit +
              "T23:59:59" +
              timeZoneIso
          );

          if (momentNow.isBetween(fromDate, toDate)) {
            url = mileStone.url;
            break;
          }
        } else {
          let fromMonth2Digit = this.converTo2Digit(mileStone.from.month);
          let fromDay2Digit = this.converTo2Digit(mileStone.from.day);

          let startYear = this.$moment(years + "-01-01T00:00:01" + timeZoneIso);
          let endYear = this.$moment(years + "-12-31T23:59:59" + timeZoneIso);
          fromDate = this.$moment(
            years +
              "-" +
              fromMonth2Digit +
              "-" +
              fromDay2Digit +
              "T00:00:01" +
              timeZoneIso
          );

          let toMonth2Digit = this.converTo2Digit(mileStone.to.month);

          let toDay2Digit = this.converTo2Digit(mileStone.to.day);

          toDate = this.$moment(
            Number(years) +
              "-" +
              toMonth2Digit +
              "-" +
              toDay2Digit +
              "T23:59:59" +
              timeZoneIso
          );

          // console.log("startYear", startYear);
          // console.log("momentNow", momentNow);
          // console.log("toDate", toDate);

          // console.log("fromDate", fromDate);
          // console.log("momentNow", momentNow);
          // console.log("endYear", endYear);

          if (
            momentNow.isBetween(startYear, toDate) ||
            momentNow.isBetween(fromDate, endYear)
          ) {
            url = mileStone.url;

            break;
          }
        }
      }

      //fall-back
      return url;
    }
  },
  mixins: [categoryDefinitions],
  async created() {
    await this.getCategoryDefinitions();
    this.$store.commit("appData/SET_CATEGORY_DEFINITIONS", this.cdRaws);
    localStorage.setItem("personal_address", "[]");
  },
  data() {
    return {
      imgBanner: this.currentBanner,

      // resultA105: {},
      // dataAlertA095: {
      //   isShow: false,
      //   isShowClose: false,
      //   opts: {
      //     keyboard: false,
      //     backdrop: "static"
      //   },
      //   isReOrder: true
      // },
      // dataAlertA105: {
      //   isShow: false,
      //   isShowClose: true,
      //   opts: {
      //     keyboard: false,
      //     backdrop: "static"
      //   },
      //   content: this.$t("front_end.a105.alert.not_found")
      // },
      // errors: {
      //   orderNumber: "",
      //   name: "",
      //   nameKana: "",
      //   email: "",
      //   phone: ""
      // },

      messageError: this.$t("front_end.a095.order_exits"),
      isAndroid: false,
      dataAlert: {
        isShow: false,
        dismissText: "",
        confirmText: "",
        content: "",
        success: "",
        img: ""
      },
      isPhoneError: false
    };
  },
  methods: {
    showErr() {
      let status = 400;
      let message = "kamen raider";
      this.$store.dispatch("errorStore/redirectErrorPage", {
        status: status,
        message: message
      });
    },
    converTo2Digit(x) {
      return x < 10 ? "0" + x : x;
    },
    clearSession() {
      //TODO CLEAR DATA REORDER, ORDER CONFIRM IMAGE
      this.$store.dispatch("userData/clearSession");
      this.$store.dispatch("reOrder/clearSession");
    },
    gotoCreatePostCard() {
      this.clearSession();
      this.clearSesisonTemplate();
      this.clearSessionReOrder();
      this.$router.push({ name: "a008" });
    },
    clearSessionReOrder() {
      this.$store.dispatch("userData/clearSessionReOrder");
    },
    // showModal() {},
    onOpenModalA095() {
      this.$router.push({ name: "a095" });
    },
    clearSesisonTemplate() {
      this.$store.dispatch("userData/clearSessionTemplate");
    }
    // onOpenModalA105() {
    //   this.$refs.modalA105.show();
    // },

    // showAlert() {
    //   this.$refs.alertComponent.show();
    // },
    // onConfirmOk() {
    //   return;
    // }
    // saveOrderToStore(event) {
    //   this.resultA105 = event.orderingInformation;
    //   this.$store.commit("reOrder/SAVE_REORDER", event.orderingInformation);
    //   this.$router.push("a110");
    // }
  }
};
</script>

<style scoped src="../../assets/css/splash/splash.css"></style>
<style scoped>
.alert-center {
  text-align: center;
  padding: 15px;
}
.modal-open .modal {
  overflow-x: unset !important;
  overflow-y: unset !important;
}
.modal-dialog {
  padding: 15px;
  background-color: transparent;
  margin-top: unset !important;
}
.modal-content {
  border-radius: 5px;
}
.btn-confirm-re-order {
  margin: 25px;
}
.pd-0 {
  padding: 0px !important;
}
@media (min-width: 576px) {
  .modal-body {
    padding: 1.5rem;
  }
}
.text-box {
  font-size: 16px;
}
</style>
